const RupiahIcon = ({ className = '', ...props }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
    {...props}
  >
    <text
      x="12"
      y="15.5"
      textAnchor="middle"
      fill="currentColor"
      fontSize="9"
      fontWeight="700"
      fontFamily="Arial, sans-serif"
    >
      Rp
    </text>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
  </svg>
);

export default RupiahIcon;
